var map = {
	"./ahlenculs.mp3": 19,
	"./ahouais.mp3": 20,
	"./albatard.mp3": 21,
	"./capartdela.mp3": 22,
	"./maisnan.mp3": 23
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds ^\.\/.*$
// module id = 18
// module chunks = 0